var map = {
	"./awq1.jpg": 6392,
	"./awq2.jpg": 9239,
	"./awq3.jpg": 7082,
	"./awq4.jpg": 2825,
	"./awq5.jpg": 4828,
	"./awq6.jpg": 9995,
	"./awq7.jpg": 4158,
	"./awq8.jpg": 9165,
	"./awq9.jpg": 8240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 944;